export const SET_LOADING = 'src/store/stadium/SET_LOADING'
export const SET_SAVE_LOADING = 'src/store/stadium/SET_SAVE_LOADING'
export const SET_PROFILE = 'src/store/stadium/SET_PROFILE'
export const SET_PROFILE_DETAIL = 'src/store/stadium/SET_PROFILE_DETAIL'
export const SET_PROFILE_RESPONSE = 'src/store/stadium/SET_PROFILE_RESPONSE'
export const SET_SUBZONE_RESPONSE = 'src/store/stadium/SET_SUBZONE_RESPONSE'
export const SET_SUBZONE_STATUS = 'src/store/stadium/SET_SUBZONE_STATUS'
export const SET_SEAT_RESPONSE = 'src/store/stadium/SET_SEAT_RESPONSE'
export const SET_SYNC_RESPONSE = 'src/store/stadium/SET_SYNC_RESPONSE'
